import { decodeToken } from "react-jwt"

const cStorageTokenKey = "cStorageToken"

export function fnSetStorageToken(cToken) {
    localStorage.setItem(cStorageTokenKey, cToken)
}

export function fnDecodeStorageToken() {
    if (!localStorage.getItem(cStorageTokenKey)) return

    return decodeToken(localStorage.getItem(cStorageTokenKey))
}